import React, { useState, useEffect } from "react";
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import { MENU_IDS, PLAYBOOK_URL } from "../constants/constants";
import { COLORS, FONT_FAMILY, BUTTON_HOVER } from "../talkTreeShared/Tree/constants/theme";

import Illustration1 from "../assets/Illustration1.svg";
import Illustration2 from "../assets/Illustration2.svg";
import Illustration3 from "../assets/Illustration3.svg";
const UserIcon = () => (
  <AccountCircleRoundedIcon style={{ width: "20px", height: "20px" }} />
);
const MicIcon = () => (
  <svg width="44" height="44" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g clipPath="url(#tt_mic_clip)">
      <path d="M25.3531 34.6515C31.0437 34.6515 35.6816 29.9921 35.6881 24.2672L35.7044 10.3909C35.7044 7.61691 34.6353 5.0069 32.6896 3.04612C30.7406 1.08533 28.1495 0.0032959 25.3923 0.0032959C19.7017 0.0032959 15.0638 4.66262 15.0573 10.3876L15.041 24.2639C15.0378 27.0379 16.11 29.6479 18.0558 31.6086C20.0048 33.5694 22.5959 34.6515 25.3531 34.6515Z" fill="#FDFBFA"/>
      <path d="M40.9613 23.3097C40.153 23.3097 39.4946 23.9688 39.4946 24.7819C39.4848 32.6218 33.1392 38.9993 25.3432 38.9993C21.569 38.9993 18.023 37.5205 15.357 34.8351C12.6909 32.1496 11.2276 28.5789 11.2308 24.7819C11.2308 23.9655 10.5757 23.3064 9.76744 23.3032C8.95916 23.3032 8.3008 23.9622 8.3008 24.7754C8.29428 29.3626 10.064 33.6743 13.2841 36.9172C16.1555 39.8092 19.8742 41.5371 23.8765 41.8814L23.87 47.0424H18.8378C18.0263 47.0424 17.3712 47.7015 17.3712 48.5179C17.3712 49.3344 18.0263 49.9934 18.8378 49.9934H31.4379C32.2494 49.9934 32.9045 49.3344 32.9045 48.5179C32.9045 47.7015 32.2494 47.0424 31.4379 47.0424H26.8033L26.8098 41.8814C35.5347 41.1306 42.4181 33.7497 42.4279 24.7819C42.4279 23.9655 41.7728 23.3064 40.9645 23.3032L40.9613 23.3097Z" fill="#FDFBFA"/>
      <path d="M50.9773 12.2631C50.8437 8.84322 50.1039 5.59055 48.7839 2.59363L46.1016 3.79043C47.2716 6.44634 47.9267 9.33505 48.0473 12.3812C48.1288 14.4862 47.9463 16.565 47.5063 18.5619L50.3679 19.2046C50.8665 16.9585 51.0718 14.6239 50.9773 12.2664V12.2631Z" fill="#FDFBFA"/>
      <path d="M42.7155 6.18402L40.0332 7.38082C40.76 9.03339 41.1674 10.8302 41.2424 12.7254C41.2945 14.037 41.1804 15.3289 40.9034 16.5749L43.765 17.2175C44.0942 15.7256 44.2311 14.1747 44.1691 12.6107C44.0811 10.3417 43.589 8.18087 42.709 6.1873L42.7155 6.18402Z" fill="#FDFBFA"/>
      <path d="M4.91093 3.41333L2.22209 2.23621C1.30951 4.34782 0.66745 6.60043 0.315456 8.93501C-0.196239 12.3188 -0.0854261 15.6535 0.647894 18.8504L2.07543 18.5192L3.50622 18.1881C2.85763 15.3584 2.75986 12.3942 3.21615 9.38094C3.53229 7.29883 4.10265 5.29214 4.91093 3.41661V3.41333Z" fill="#FDFBFA"/>
      <path d="M8.70847 16.1486L10.136 15.8174C9.73186 14.0567 9.6732 12.2139 9.95675 10.3384C10.1523 9.04323 10.5076 7.79069 11.0127 6.6234L9.66668 6.03648L8.32063 5.44955C7.71442 6.85293 7.29072 8.3481 7.05606 9.89575C6.7171 12.1418 6.79206 14.3583 7.27768 16.4831L8.70847 16.1519V16.1486Z" fill="#FDFBFA"/>
    </g>
    <defs><clipPath id="tt_mic_clip"><rect width="51" height="50" fill="white"/></clipPath></defs>
  </svg>
);

const SimulateIcon = () => (
  <svg width="44" height="44" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M49.4047 38.8296H2.59529C1.7155 38.8296 1 38.1205 1 37.2427C1 36.3649 1.71285 35.6558 2.59529 35.6558H49.4047C50.2845 35.6558 51 36.3649 51 37.2427C51 38.1205 50.2872 38.8296 49.4047 38.8296Z" fill="#E7E3DF"/>
    <path d="M30.8764 34.024H30.8737C29.9576 34.024 29.2148 34.7629 29.2148 35.6742V38.3498C29.2148 39.2612 29.9576 40 30.8737 40H30.8764C31.7926 40 32.5353 39.2612 32.5353 38.3498V35.6742C32.5353 34.7629 31.7926 34.024 30.8764 34.024Z" fill="#FDFBFA"/>
    <path d="M49.4047 30.3625H2.59529C1.7155 30.3625 1 29.6534 1 28.7756C1 27.8978 1.71285 27.1887 2.59529 27.1887H49.4047C50.2845 27.1887 51 27.8978 51 28.7756C51 29.6534 50.2872 30.3625 49.4047 30.3625Z" fill="#E7E3DF"/>
    <path d="M16.0307 25.5544H16.028C15.1119 25.5544 14.3691 26.2932 14.3691 27.2046V29.8802C14.3691 30.7916 15.1119 31.5304 16.028 31.5304H16.0307C16.9469 31.5304 17.6896 30.7916 17.6896 29.8802V27.2046C17.6896 26.2932 16.9469 25.5544 16.0307 25.5544Z" fill="#FDFBFA"/>
    <path d="M49.4047 22.0827H2.59529C1.7155 22.0827 1 21.3736 1 20.4958C1 19.618 1.71285 18.9089 2.59529 18.9089H49.4047C50.2845 18.9089 51 19.618 51 20.4958C51 21.3736 50.2872 22.0827 49.4047 22.0827Z" fill="#E7E3DF"/>
    <path d="M43.4447 17.2772H43.4421C42.5259 17.2772 41.7832 18.016 41.7832 18.9274V21.603C41.7832 22.5144 42.5259 23.2532 43.4421 23.2532H43.4447C44.3609 23.2532 45.1036 22.5144 45.1036 21.603V18.9274C45.1036 18.016 44.3609 17.2772 43.4447 17.2772Z" fill="#FDFBFA"/>
    <path d="M49.4047 13.8055H2.59529C1.7155 13.8055 1 13.0964 1 12.2186C1 11.3408 1.71285 10.6317 2.59529 10.6317H49.4047C50.2845 10.6317 51 11.3408 51 12.2186C51 13.0964 50.2872 13.8055 49.4047 13.8055Z" fill="#E7E3DF"/>
    <path d="M34.6791 9H34.6765C33.7603 9 33.0176 9.73881 33.0176 10.6502V13.3258C33.0176 14.2371 33.7603 14.9759 34.6765 14.9759H34.6791C35.5953 14.9759 36.338 14.2371 36.338 13.3258V10.6502C36.338 9.73881 35.5953 9 34.6791 9Z" fill="#FDFBFA"/>
  </svg>
);

const UploadIcon = () => (
  <svg width="44" height="44" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g clipPath="url(#tt_upload_clip)">
      <path d="M38.6138 12.9696C36.4578 9.82538 33.2391 7.55053 29.5378 6.55699C20.978 4.25488 12.1586 9.27409 9.83773 17.7646C4.78367 18.428 1.00611 22.7021 1.00001 27.7576C0.993899 33.3281 5.54407 37.8506 11.16 37.8566H20.5199C21.5582 37.8566 22.398 37.0206 22.398 35.9937C22.398 34.9669 21.5552 34.1308 20.5199 34.1308H11.16C11.0562 34.1308 10.9524 34.1308 10.8485 34.1308C7.30917 34.043 4.50883 31.129 4.59739 27.6183C4.6829 24.1076 7.62371 21.3299 11.1631 21.4177H11.2974C12.238 21.451 13.0625 20.7907 13.2213 19.8668C13.8382 16.3016 16.0186 13.1937 19.1732 11.3793C25.0487 7.99884 32.5764 9.98592 35.9814 15.8139C36.3478 16.4379 37.041 16.7984 37.7679 16.7347C38.0488 16.7105 38.2992 16.6984 38.5374 16.6984C43.3075 16.756 47.1614 20.5787 47.2194 25.3071C47.2774 30.1203 43.3899 34.0703 38.5374 34.1278H31.5503C30.512 34.1278 29.6722 34.9608 29.6722 35.9907C29.6722 37.0206 30.5151 37.8536 31.5503 37.8536H38.5374C45.3718 37.8082 50.9145 32.3467 51 25.5676C51.0886 18.6946 45.5429 13.0544 38.6138 12.9696Z" fill="#FDFBFA"/>
      <path d="M32.0747 29.0151H32.0808C32.5786 29.0151 33.058 28.8182 33.4092 28.4699C34.1421 27.7429 34.1421 26.5615 33.4092 25.8345L27.3718 19.846C26.6389 19.119 25.4479 19.119 24.715 19.846L18.6776 25.8345C18.0241 26.5464 18.0241 27.6338 18.6776 28.3457C19.377 29.106 20.5649 29.1635 21.3314 28.4699L24.1592 25.6649V42.1341C24.1592 43.164 24.999 43.997 26.0373 43.997C27.0756 43.997 27.9154 43.164 27.9154 42.1341V25.6619L30.7432 28.4668C31.0944 28.8182 31.5739 29.0151 32.0716 29.0151H32.0747Z" fill="#FDFBFA"/>
    </g>
    <defs><clipPath id="tt_upload_clip"><rect width="51" height="50" fill="white"/></clipPath></defs>
  </svg>
);


const CREATE_TREE_OPTIONS = {
  [MENU_IDS.SIMULATOR]: {
    id: MENU_IDS.SIMULATOR,
    label: "Tree Simulator",
    modalTitle: "Quick Tree Simulator",
    modalDesc:
      "Answer a few questions about your classroom discussion habits, and our simulator will generate a talk tree instantly.",
    illustration: Illustration1,
    mobileTitle: "Simulate Tree",
    mobileDesc: "Simulate a talk tree by answering questions",
    Icon: SimulateIcon,
  },
  [MENU_IDS.UPLOAD]: {
    id: MENU_IDS.UPLOAD,
    label: "Upload Recording",
    modalTitle: "Upload a Recording",
    modalDesc:
      "Already have a classroom discussion recorded? Upload a recording or transcript to generate a Talk Tree from real classroom talk.",
    illustration: Illustration2,
    mobileTitle: "Upload Recording",
    mobileDesc: "Create a talk tree from a past classroom recording",
    Icon: UploadIcon,
  },
  [MENU_IDS.STREAM]: {
    id: MENU_IDS.STREAM,
    label: "Start Streaming",
    modalTitle: "Stream Your Classroom Live",
    modalDesc:
      "Stream into Talk Trees during a live classroom discussion to generate a Talk Tree.",
    illustration: Illustration3,
    mobileTitle: "Stream Live",
    mobileDesc: "Stream your classroom discussion live to create a Talk Tree",
    Icon: MicIcon,
  },
};

const DESKTOP_ORDER = [MENU_IDS.SIMULATOR, MENU_IDS.UPLOAD, MENU_IDS.STREAM];
const MOBILE_ORDER = [MENU_IDS.STREAM, MENU_IDS.SIMULATOR, MENU_IDS.UPLOAD];
const CREATE_BTN_HOVER_BG = BUTTON_HOVER.gradient;
const CREATE_BTN_HOVER_SHADOW = BUTTON_HOVER.shadow;

function Navbar({ activeMenu, setActiveMenu, userName, handleLogout }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [createTreeExpanded, setCreateTreeExpanded] = useState(false);
  const [createTreeOpen, setCreateTreeOpen] = useState(false);

  const navItems = [
    { id: MENU_IDS.LIBRARY, label: "Tree Library" },
  ];

  const mobileTopLevelItems = [
    { id: MENU_IDS.RECORDINGS, label: "Manage Trees" },
  ];

  const externalNavItems = [
    { id: "playbooks", label: "Playbooks", externalUrl: PLAYBOOK_URL, windowName: "talkTreesPlaybook" },
    //{ id: "documentation", label: "Get Help", externalUrl: DOCS_URL, windowName: "talkTreesDocs" },
  ];

  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest("#tt-user-pill")) setDropdownOpen(false);
      if (!e.target.closest("#tt-mobile-menu") && !e.target.closest("#tt-hamburger")) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    const handler = () => {
      if (window.innerWidth > 1350) setMobileMenuOpen(false);
    };
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  // Close the Create a Tree modal on Escape
  useEffect(() => {
    if (!createTreeOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") {
        mixpanel.track("createATreeModalClosed", { method: "escape_key" });
        setCreateTreeOpen(false);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [createTreeOpen]);

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen || createTreeOpen ? "hidden" : "";
    if (mobileMenuOpen) setCreateTreeExpanded(false);
    return () => { document.body.style.overflow = ""; };
  }, [mobileMenuOpen, createTreeOpen]);

  const isUploadActive = activeMenu === MENU_IDS.UPLOAD;
  const isStreamActive = activeMenu === MENU_IDS.STREAM;
  const isSimulatorActive = activeMenu === MENU_IDS.SIMULATOR;
  const isCreateTreeGroupActive = isUploadActive || isStreamActive || isSimulatorActive || createTreeOpen;

  const handleNavClick = (item) => {
    mixpanel.track("navigationItemClicked", {
      label: item.label,
      menuId: item.id,
      isExternal: !!item.externalUrl
    });

    if (item.externalUrl) {
      window.open(item.externalUrl, item.windowName || "_blank");
    } else {
      setActiveMenu(item.id);
    }
    setMobileMenuOpen(false);
  };

  const handleExternalNavClick = (item) => {
    mixpanel.track("externalLinkClicked", {
      label: item.label,
      linkId: item.id,
    });
    window.open(item.externalUrl, item.windowName || "_blank");
    setMobileMenuOpen(false);
  };

  const handleCreateTreeSelect = (option, source) => {
    mixpanel.track("createATreeOptionSelected", {
      optionId: option.id,
      label: option.label,
      source, // "desktop_modal" | "mobile_submenu"
    });
    handleNavClick({ id: option.id, label: option.label });
    setCreateTreeOpen(false);
  };

  const handleManageMyTrees = () => {
    setDropdownOpen(false);
    handleNavClick({ id: MENU_IDS.RECORDINGS, label: "Manage My Trees" });
  };

  return (
    <div style={{ fontFamily: FONT_FAMILY }}>
      <style>{`
        @media (max-width: 1350px) {
          .tt-desktop-nav { display: none !important; }
          .tt-hamburger-btn { display: flex !important; }
        }
        @media (min-width: 1351px) {
          .tt-desktop-nav { display: flex !important; }
          .tt-hamburger-btn { display: none !important; }
          .tt-mobile-menu { display: none !important; }
        }
        @keyframes tt-fade-in {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes tt-modal-in {
          from { opacity: 0; transform: translateY(10px) scale(0.985); }
          to   { opacity: 1; transform: none; }
        }
        .tt-hamburger-btn {
          display: none;
          align-items: center;
          justify-content: center;
          background: none;
          border: none;
          cursor: pointer;
          padding: 6px;
          border-radius: 8px;
          color: ${COLORS.text};
          font-family: inherit;
          transition: background 0.12s ease;
        }
        .tt-hamburger-btn:hover { background: #f3f4f6; }

        /* ---------- Create a Tree modal (desktop) ---------- */
        .tt-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(24, 22, 20, 0.45);
          z-index: 3000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
          box-sizing: border-box;
          overflow-y: auto;
          animation: tt-fade-in 0.15s ease;
        }
        .tt-modal {
          position: relative;
          width: 100%;
          max-width: 640px;
          background: #f9f7f6;
          border-radius: 14px;
          box-shadow: 0 24px 60px rgba(0,0,0,0.22);
          padding: 36px 40px 40px;
          box-sizing: border-box;
          animation: tt-modal-in 0.18s ease;
        }
        .tt-modal-title {
          margin: 0 0 28px;
          font-size: 34px;
          font-weight: 500;
          color: ${COLORS.primary};
          font-family: inherit;
          letter-spacing: -0.01em;
        }
        .tt-modal-close {
          position: absolute;
          top: 22px;
          right: 24px;
          background: none;
          border: none;
          padding: 6px;
          cursor: pointer;
          border-radius: 8px;
          display: flex;
          color: ${COLORS.text};
          transition: background 0.12s ease;
        }
        .tt-modal-close:hover { background: rgba(0,0,0,0.06); }

        .tt-option-list { display: flex; flex-direction: column; gap: 16px; }
        .tt-option-card {
          display: flex;
          align-items: center;
          gap: 26px;
          width: 100%;
          text-align: left;
          background: linear-gradient(100deg, #f4efec 0%, #ebe3dd 100%);
          border: 1px solid #e3dbd5;
          border-radius: 10px;
          padding: 22px 26px;
          cursor: pointer;
          font-family: inherit;
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
        }
        .tt-option-card:hover,
        .tt-option-card:focus-visible {
          border-color: ${COLORS.primary};
          box-shadow: 0 4px 14px rgba(0,0,0,0.08);
          outline: none;
        }
        .tt-option-card.active { border-color: ${COLORS.primary}; }
        .tt-option-illustration { width: 104px; height: auto; flex-shrink: 0; }
        .tt-option-title {
          margin: 0 0 10px;
          font-size: 23px;
          font-weight: 500;
          color: ${COLORS.text};
          line-height: 1.2;
        }
        .tt-option-desc {
          margin: 0;
          font-size: 15px;
          line-height: 1.5;
          color: ${COLORS.textMuted};
        }

        /* "Manage Trees" link at the bottom of the Create a Tree modal */
        .tt-modal-footer { display: flex; justify-content: center; margin-top: 28px; }
        .tt-manage-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: none;
          border: none;
          cursor: pointer;
          color: ${COLORS.primary};
          font-family: inherit;
          font-size: 15px;
          padding: 6px 10px;
          border-radius: 6px;
        }
        .tt-manage-link:hover { background: rgba(31, 114, 231, 0.08); }
        .tt-manage-link:focus-visible { outline: 2px solid ${COLORS.primary}; }

        @media (max-width: 620px) {
          .tt-modal { padding: 28px 20px 30px; }
          .tt-option-card { gap: 16px; padding: 18px; }
          .tt-option-illustration { width: 72px; }
          .tt-option-title { font-size: 19px; }
        }

        /* ---------- Mobile menu ---------- */
        .tt-mobile-menu {
          position: fixed;
          inset: 0;
          background: ${COLORS.primaryDark};
          z-index: 2000;
          display: flex;
          flex-direction: column;
          padding: 20px 24px 32px;
          box-sizing: border-box;
          overflow-y: auto;
          animation: tt-fade-in 0.18s ease;
        }
        .tt-mobile-menu-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 28px;
        }
        .tt-mobile-menu-logo { height: 28px; width: auto; display: block; }
        .tt-mobile-close-btn {
          background: none;
          border: none;
          padding: 6px;
          margin: -6px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          transition: background 0.12s ease;
        }
        .tt-mobile-close-btn:hover { background: rgba(255,255,255,0.12); }

        .tt-mobile-user-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 22px;
        }
        .tt-mobile-user-icon {
          width: 26px; height: 26px;
          display: flex; align-items: center; justify-content: center;
          color: #fff;
        }
        .tt-mobile-user-name { color: #fff; font-size: 17px; font-weight: 700; }
        .tt-mobile-logout-link {
          background: none;
          border: none;
          color: #fff;
          font-size: 15px;
          font-weight: 500;
          text-decoration: underline;
          cursor: pointer;
          font-family: inherit;
          padding: 4px;
        }

        .tt-mobile-nav-list { display: flex; flex-direction: column; }
        .tt-mobile-nav-item-lg {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          background: none;
          border: none;
          color: #fff;
          font-size: 19px;
          font-weight: 700;
          font-family: inherit;
          cursor: pointer;
          padding: 15px 0;
          text-align: left;
        }
        .tt-mobile-nav-item-lg.active { text-decoration: underline; }

        .tt-chevron { transition: transform 0.18s ease; flex-shrink: 0; }
        .tt-chevron--open { transform: rotate(180deg); }

        .tt-mobile-submenu {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin: 6px 0 14px;
        }
        .tt-mobile-option-card {
          display: flex;
          align-items: center;
          gap: 18px;
          width: 100%;
          text-align: left;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.28);
          border-radius: 10px;
          padding: 18px 16px;
          cursor: pointer;
          font-family: inherit;
        }
        .tt-mobile-option-card.active { border-color: #fff; background: rgba(255,255,255,0.12); }
        .tt-mobile-option-icon { flex-shrink: 0; display: flex; align-items: center; justify-content: center; width: 52px; }
        .tt-mobile-option-title {
          margin: 0 0 6px;
          color: #fff;
          font-size: 22px;
          font-weight: 500;
          line-height: 1.15;
        }
        .tt-mobile-option-desc {
          margin: 0;
          color: rgba(255,255,255,0.82);
          font-size: 15px;
          line-height: 1.4;
        }

        .tt-mobile-gethelp-btn {
          margin-top: 20px;
          width: 100%;
          background: none;
          border: 1.5px solid #fff;
          color: #fff;
          border-radius: 8px;
          padding: 14px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          font-family: inherit;
        }
        .tt-mobile-gethelp-btn:hover { background: rgba(255,255,255,0.08); }
      `}</style>

      <nav
        aria-label="Main navigation"
        style={{
          backgroundColor: "#f9f7f6",
          padding: "28px 28px 8px 28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "65px",
          position: "sticky",
          top: 0,
          zIndex: 1000,
          boxSizing: "border-box",
        }}>

        {/* Talk Trees brand */}
        <img
          src="/TTLogo.svg"
          alt="Talk Trees"
          aria-label="Talk Trees home"
          style={{
            height: "26px", width: "auto", display: "block",
            userSelect: "none", flexShrink: 0, cursor: "pointer",
          }}
          onClick={() => handleNavClick({ id: MENU_IDS.LIBRARY, label: "Tree Library" })}
        />

        {/* Desktop: Right side */}
        <div className="tt-desktop-nav" style={{
          alignItems: "center",
          marginLeft: "auto",
          gap: "4px",
          height: "100%",
        }}>

          {navItems.map((item) => {
            const isActive = activeMenu === item.id;
            return (
              <div
                key={item.id}
                style={{ position: "relative", height: "100%", display: "flex", alignItems: "center" }}
              >
                <button
                  onClick={() => handleNavClick(item)}
                  aria-label={item.label}
                  aria-current={isActive ? 'page' : undefined}
                  style={{
                    background: "none",
                    border: "none",
                    padding: "0 20px",
                    cursor: "pointer",
                    fontSize: "14.5px",
                    fontWeight: isActive ? 600 : 500,
                    color: isActive ? COLORS.primary : COLORS.textMuted,
                    transition: "color 0.15s ease",
                    whiteSpace: "nowrap",
                    fontFamily: "inherit",
                    outline: "none",
                    lineHeight: 1,
                  }}
                  onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.color = COLORS.text; }}
                  onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.color = COLORS.textMuted; }}
                >
                  {item.label}
                </button>

                {isActive && (
                  <span style={{
                    position: "absolute",
                    bottom: "-8px",
                    left: 0,
                    right: 0,
                    height: "3px",
                    borderRadius: "100px 100px 0 0",
                    backgroundColor: COLORS.primary,
                    pointerEvents: "none",
                  }} />
                )}
              </div>
            );
          })}

          {/* Create a Tree — opens modal */}
          <div style={{ position: "relative", display: "flex", alignItems: "center", height: "100%", paddingLeft: "12px" }}>
            <button
              id="tt-create-tree-desktop"
              onClick={() => {
                mixpanel.track("createATreeModalOpened", { source: "desktop_navbar" });
                setCreateTreeOpen(true);
              }}
              aria-label="Create a new tree"
              aria-haspopup="dialog"
              aria-expanded={createTreeOpen}
              aria-current={isCreateTreeGroupActive ? 'page' : undefined}
              style={{
                background: COLORS.primaryDark,
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "9px 20px",
                fontSize: "14px",
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: "inherit",
                transition: "background 0.15s ease, box-shadow 0.15s ease",
                whiteSpace: "nowrap",
                lineHeight: 1,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = CREATE_BTN_HOVER_BG;
                e.currentTarget.style.boxShadow = CREATE_BTN_HOVER_SHADOW;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = COLORS.primaryDark;
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              Create a Tree
            </button>

            {isCreateTreeGroupActive && (
              <span style={{
                position: "absolute",
                bottom: "-8px",
                left: "12px",
                right: 0,
                height: "3px",
                borderRadius: "100px 100px 0 0",
                backgroundColor: COLORS.primary,
                pointerEvents: "none",
              }} />
            )}
          </div>

          {externalNavItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleExternalNavClick(item)}
              aria-label={item.label}
              style={{
                background: "none",
                border: "none",
                padding: "0 16px",
                cursor: "pointer",
                fontSize: "14.5px",
                fontWeight: 500,
                color: COLORS.primary,
                whiteSpace: "nowrap",
                fontFamily: "inherit",
                outline: "none",
                lineHeight: 1,
              }}
            >
              {item.label}
            </button>
          ))}

          <div style={{ display: "flex", alignItems: "center", paddingLeft: "8px" }}>
            <div
              id="tt-user-pill"
              onClick={() => {
                if (!dropdownOpen) mixpanel.track("userMenuOpened");
                setDropdownOpen((p) => !p);
              }}
              aria-haspopup="true"
              aria-expanded={dropdownOpen}
              aria-label="User menu"
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  if (!dropdownOpen) mixpanel.track("userMenuOpened");
                  setDropdownOpen(p => !p);
                }
              }}
              style={{
                display: "flex", alignItems: "center", gap: "6px",
                padding: "5px 10px 5px 6px",
                cursor: "pointer", fontSize: "14px", fontWeight: 500,
                color: COLORS.primary,
                userSelect: "none", position: "relative",
                background: "transparent", transition: "background 0.12s ease",
                borderRadius: "4px",
                lineHeight: 1,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f9fafb")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <div style={{
                width: "26px", height: "26px", borderRadius: "50%",
                display: "flex", alignItems: "center", justifyContent: "center",
                color: COLORS.primaryDark, flexShrink: 0,
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill={COLORS.primary} />
                </svg>
              </div>
              <span style={{ whiteSpace: "nowrap" }}>Hi, {userName || "User"}</span>

              {dropdownOpen && (
                <div style={{
                  position: "absolute", top: "calc(100% + 8px)", right: 0,
                  backgroundColor: "#fff", border: `1px solid ${COLORS.hairline}`,
                  borderRadius: "10px", boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                  minWidth: "140px", zIndex: 300, overflow: "hidden",
                }}>
                  <div
                    onClick={(e) => { e.stopPropagation(); handleManageMyTrees(); }}
                    role="button"
                    tabIndex={0}
                    aria-label="Manage My Trees"
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); handleManageMyTrees(); } }}
                    style={{ padding: "10px 16px", fontSize: "13.5px", color: COLORS.text, fontWeight: 500, cursor: "pointer", textAlign: "left", whiteSpace: "nowrap" }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9fafb")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                  >
                    Manage My Trees
                  </div>
                  <div
                    onClick={handleLogout}
                    role="button"
                    tabIndex={0}
                    aria-label="Logout"
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleLogout(); } }}
                    style={{ padding: "10px 16px", fontSize: "13.5px", color: COLORS.text, fontWeight: 500, cursor: "pointer", textAlign: "left" }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9fafb")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                  >
                    Log out
                  </div>
                </div>
              )}
            </div>
          </div>

        </div>

        {/* Mobile/Tablet: Hamburger button */}
        <button
          id="tt-hamburger"
          className="tt-hamburger-btn"
          onClick={() => {
            const willOpen = !mobileMenuOpen;
            mixpanel.track(willOpen ? "mobileMenuOpened" : "mobileMenuClosed");
            setMobileMenuOpen((p) => !p);
          }}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
            <path d="M3 6h16M3 11h16M3 16h16" stroke={COLORS.text} strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        {/* Mobile/Tablet: full-screen menu overlay */}
        {mobileMenuOpen && (
          <div id="tt-mobile-menu" className="tt-mobile-menu" role="dialog" aria-modal="true" aria-label="Mobile navigation menu">
            <div className="tt-mobile-menu-header">
              <svg width="168" height="30" viewBox="0 0 168 30" fill="none" xmlns="http://www.w3.org/2000/svg" className="tt-mobile-menu-logo" aria-label="Talk Trees">
                <g clipPath="url(#clip0_2838_22366)">
                  <path d="M15.9897 6.27231C15.6277 6.41241 15.4467 6.82286 15.5861 7.18661C15.7255 7.55037 16.134 7.73225 16.496 7.59215C16.858 7.45206 17.039 7.0416 16.8996 6.67785C16.7602 6.31409 16.3517 6.13222 15.9897 6.27231Z" fill="#FDFBFA"/>
                  <path d="M9.59819 13.4442C9.96754 13.3263 10.173 12.9281 10.0556 12.5545C9.93819 12.1834 9.54194 11.9769 9.17014 12.0949C8.80079 12.2129 8.59533 12.6111 8.71273 12.9846C8.83014 13.3558 9.2264 13.5622 9.59819 13.4442Z" fill="#FDFBFA"/>
                  <path d="M16.7382 15.435C16.4349 15.1917 15.9922 15.2409 15.7476 15.5456C15.5054 15.8504 15.5544 16.2953 15.8577 16.5411C16.161 16.7868 16.6037 16.7352 16.8483 16.4305C17.0905 16.1257 17.0415 15.6808 16.7382 15.435Z" fill="#FDFBFA"/>
                  <path d="M21.9386 26.1903C22.3177 26.1878 22.895 26.1903 22.895 26.1903C24.2892 26.1706 25.4095 24.9122 25.3899 23.5088L25.3777 2.50685C25.3581 1.1059 24.2061 -0.019775 22.8118 -0.000112493L2.48297 0.324318C1.08873 0.343981 -0.0193129 1.50161 0.000255236 2.90502V23.907C0.0198234 25.3079 1.1719 26.4336 2.56613 26.4139L11.8928 26.264L11.954 24.1847C10.8508 24.0372 9.2511 23.6686 8.77413 23.5285C5.13934 22.4569 2.9844 21.5057 2.23103 20.9748C1.47765 20.4439 1.41895 20.176 1.41895 20.176C1.41895 20.176 2.37779 20.7241 3.6008 21.051C3.6277 20.525 3.29015 19.6525 3.29015 19.6525C3.29015 19.6525 4.00194 20.2178 4.4618 21.341C4.81158 21.4516 5.5038 21.6974 6.39171 21.9358C7.0986 22.1251 8.00119 22.3438 8.36075 22.4126C8.20421 21.6163 7.5022 20.3309 7.5022 20.3309C7.5022 20.3309 7.97428 20.6135 8.50996 21.1346C8.9747 21.5893 9.56909 22.3536 9.8039 22.5994L11.9906 22.8722L12.1399 17.3053C10.6209 17.1013 8.90377 16.7228 7.48997 16.2829C6.12754 17.325 5.26898 17.0423 5.26898 17.0423C5.26898 17.0423 6.18624 16.3443 6.46019 15.8896C5.89272 15.6684 5.30078 15.4275 4.72352 15.1179C2.7667 14.0708 2.40225 13.6137 1.65866 12.3061C1.65866 12.3061 2.83519 13.3876 5.4402 14.3387C5.69704 13.0017 5.47689 11.7974 5.47689 11.7974C5.47689 11.7974 6.53602 12.7068 6.37458 14.6853C8.16018 15.3096 10.0632 15.7299 12.1741 15.9609L12.3258 10.2022C11.8904 10.1408 11.0587 10.0204 9.777 9.66645C7.73457 8.8652 7.0399 7.92877 7.0399 7.92877C7.04969 7.93369 8.41946 8.32694 9.65714 8.64891C9.91397 7.74935 9.87484 6.16898 9.87484 6.16898C10.2711 6.74657 10.6307 7.16931 10.3738 8.87012C11.0709 9.01021 11.6262 9.08886 12.3429 9.16505L12.4187 6.80556C12.4187 6.80556 12.678 1.15751 12.7636 2.4282C12.8468 3.69889 12.9666 5.92075 12.9666 5.92075C13.0229 6.17882 13.1109 10.1801 13.1476 11.817L14.2214 11.7236C14.2679 10.5144 14.7546 9.39609 15.5496 8.69561C15.5496 8.69561 15.2439 9.31498 15.1509 10.3964C15.1167 10.7897 15.1607 11.3353 15.1827 11.6081C16.9023 11.3623 17.8807 11.2001 19.067 10.7331C19.5562 10.5414 20.378 10.1211 20.7401 9.9024C20.7401 9.9024 20.608 10.7479 17.9956 12.0628C18.1204 12.2643 18.2989 12.5322 18.8322 12.9353C19.3532 13.3286 20.1359 13.6506 20.1359 13.6506C18.8762 13.6948 17.5749 13.218 16.9756 12.3799C15.782 12.692 14.537 12.9132 13.1819 13.0508L13.3506 19.4215C13.3506 19.4215 17.1371 19.5149 21.0703 17.5781C21.6989 17.2684 22.3251 16.8654 22.8412 16.5065C23.3573 16.1501 23.7878 15.7274 23.7878 15.7274C23.7878 15.7274 23.6435 16.6466 22.2395 17.8854L22.2248 17.8952C22.5966 18.0156 23.1518 18.0746 23.7976 18.023C23.7976 18.023 23.1983 18.7456 21.4372 18.4236C20.5003 18.9201 19.2749 19.4338 18.0445 19.8098C18.3112 20.0949 18.5949 20.3137 18.8297 20.4808C19.0327 20.6258 20.1457 21.4 20.1457 21.4C20.1457 21.4 18.1742 21.287 16.9854 20.0974C15.8774 20.3751 14.7228 20.5791 13.3849 20.7315L13.5023 26.2345L16.4913 26.1878C16.665 26.2444 16.8338 26.3378 16.9879 26.4926C18.8273 28.3605 21.1192 29.3682 23.6092 29.9974C21.4934 26.6868 21.4176 26.1903 21.9459 26.1878L21.9386 26.1903ZM9.7134 19.4239C11.0294 19.7828 11.8047 21.0977 11.4574 22.4544C10.1194 22.13 9.33427 20.7192 9.7134 19.4239ZM9.19484 17.1701C8.68852 18.4556 7.18911 19.043 5.9661 18.4851C6.50178 17.2242 7.90579 16.6368 9.19484 17.1701ZM5.97833 21.4418C4.64036 21.1174 3.85518 19.7066 4.23432 18.4113C5.55027 18.7702 6.32566 20.0851 5.97833 21.4418ZM5.65545 16.0617C4.85805 17.1873 3.2608 17.3938 2.20657 16.5581C3.02843 15.4644 4.53273 15.2309 5.65545 16.0617ZM5.09042 13.8324C3.75245 13.508 2.96728 12.0972 3.34641 10.802C4.66237 11.1608 5.43776 12.4757 5.09042 13.8324ZM8.8842 11.5024C8.92578 11.4754 8.93801 10.5906 9.85282 10.1875C10.5108 11.0109 10.2711 11.8023 10.3347 11.7998C10.8679 11.7703 11.5455 11.9399 11.9344 12.3061C11.6017 12.8026 11.1321 13.1098 10.572 13.3286C10.9266 14.0438 10.6698 15.1129 10.6698 15.1129C10.6698 15.1129 9.70117 14.8008 9.22909 14.0217C8.72521 14.3437 8.07946 14.6238 7.48752 14.587C7.48997 13.9774 7.71011 13.4318 8.07946 12.928C7.61716 12.5298 7.24047 12.0726 7.12307 11.5C7.89356 11.1583 8.8524 11.5245 8.8842 11.5049V11.5024ZM9.30736 8.14015C8.0232 7.64367 7.42393 6.14195 7.96694 4.90813C9.22664 5.4341 9.82592 6.83997 9.30736 8.14015ZM12.179 5.9994C10.8092 5.87896 9.82347 4.6009 10.0069 3.2614C11.362 3.4187 12.3233 4.60582 12.179 5.9994ZM15.2487 1.88503C15.5349 3.20487 14.6544 4.55666 13.2968 4.78524C13.0449 3.40641 13.9108 2.15047 15.2487 1.88503ZM17.1248 9.35185C16.5647 9.14293 15.9825 8.73248 15.7844 8.14506C14.7864 8.65137 13.8447 8.20651 13.8447 8.20651C13.8447 8.20651 14.1945 7.35611 14.9405 6.83505C14.5908 6.3484 14.3657 5.77574 14.3682 5.18095C14.9748 5.14654 15.4346 5.23748 15.9581 5.57665C16.3274 5.08755 16.7066 4.75329 17.2692 4.6009C17.6605 5.30138 17.4379 6.2206 17.4526 6.25992C17.4648 6.29187 18.1717 6.26238 18.8615 7.22584C18.1228 7.96318 17.2447 7.69774 17.2643 7.75919C17.4233 8.26058 17.4184 8.58501 17.1199 9.35185H17.1248ZM18.4506 10.4898C18.1986 9.11098 19.0645 7.85504 20.4025 7.5896C20.6887 8.90944 19.8081 10.2612 18.4506 10.4898ZM17.5994 16.1821C17.9883 16.5336 18.1473 16.8162 18.2745 17.6297C17.6874 17.733 16.9756 17.674 16.5133 17.2684C15.9067 18.2098 14.8696 18.3056 14.8696 18.3056C14.8696 18.3056 14.7449 17.3938 15.1264 16.5655C14.5785 16.3222 14.0991 15.9412 13.8007 15.4275C14.307 15.0908 14.7522 14.936 15.3735 14.963C15.4469 14.3559 15.6059 13.8742 16.0143 13.4564C16.7041 13.8619 16.9732 14.7713 17.0074 14.7959C17.0343 14.818 17.6287 14.4346 18.7099 14.9139C18.4432 15.9265 17.5529 16.1403 17.5994 16.1845V16.1821ZM20.0894 17.7035C19.5611 16.4402 20.1188 15.0171 21.3956 14.4567C21.9631 15.7176 21.3393 17.207 20.0894 17.7035ZM18.6683 12.1783C19.7837 11.3378 21.2904 11.554 22.1221 12.6404C21.0752 13.4883 19.4779 13.2966 18.6683 12.1783ZM19.2284 20.1687C20.1432 19.1093 21.6598 19.0037 22.7018 19.8885C21.8554 20.938 20.2533 21.0903 19.2284 20.1687ZM16.7897 22.9337C15.486 23.2655 14.1138 22.4225 13.8423 21.0682C15.2047 20.7708 16.484 21.5991 16.7897 22.9337Z" fill="#FDFBFA"/>
                  <path d="M37.8325 3.41145H31.1133V0.931519H47.6019V3.41145H40.8484V25.5243H37.8325V3.41145Z" fill="#FDFBFA"/>
                  <path d="M60.9719 22.9781C59.6682 24.9419 57.7162 25.9053 55.1088 25.9053C50.3782 25.9053 47.3965 22.5652 47.3965 17.3276C47.3965 12.09 50.3782 8.78424 55.1088 8.78424C57.748 8.78424 59.6339 9.67888 60.9352 11.5739L60.9694 9.16274H63.6772V25.5244H61.1749L60.9694 22.9756L60.9719 22.9781ZM50.3806 17.362C50.3806 21.2207 52.3692 23.6319 55.5564 23.6319C58.7436 23.6319 60.8007 21.1863 60.8007 17.4308C60.8007 13.6753 58.7778 11.0577 55.5564 11.0577C52.335 11.0577 50.3806 13.5032 50.3806 17.362Z" fill="#FDFBFA"/>
                  <path d="M68.8232 0.7005H71.7022V25.5268H68.8232V0.7005Z" fill="#FDFBFA"/>
                  <path d="M76.8096 0.7005H79.6885V15.467L86.6817 9.16273H90.0768L82.296 16.1208L90.7641 25.5244H87.4057L79.6934 16.8778V25.5244H76.8145V0.7005H76.8096Z" fill="#FDFBFA"/>
                  <path d="M97.5522 3.41145H90.833V0.931519H107.322V3.41145H100.568V25.5243H97.5522V3.41145Z" fill="#FDFBFA"/>
                  <path d="M108.212 9.1652H110.851L110.954 11.4387C112.36 9.61252 113.799 8.82111 115.821 8.82111C116.164 8.82111 116.438 8.85552 117.091 8.92433L116.612 11.4043C116.029 11.2666 115.687 11.1978 115.239 11.1978C113.764 11.1978 112.463 12.0236 111.81 13.3681C111.296 14.3659 111.091 15.7448 111.091 17.9838V25.5268H108.212V9.1652Z" fill="#FDFBFA"/>
                  <path d="M121.308 18.087C121.377 21.6017 123.571 23.6318 127.342 23.6318C129.365 23.6318 131.183 23.1845 132.724 22.3218L133.614 24.4232C131.625 25.4555 129.637 25.9028 127.306 25.9028C121.719 25.9028 118.461 22.7691 118.461 17.3595C118.461 11.9499 121.545 8.81616 126.552 8.81616C131.559 8.81616 134.402 11.881 134.402 16.9441V18.0796H121.306L121.308 18.087ZM131.594 15.8824C131.388 12.7487 129.673 11.0945 126.623 11.0945C123.573 11.0945 121.619 12.8175 121.379 15.8824H131.594Z" fill="#FDFBFA"/>
                  <path d="M140.438 18.087C140.506 21.6017 142.701 23.6318 146.472 23.6318C148.495 23.6318 150.313 23.1845 151.854 22.3218L152.744 24.4232C150.755 25.4555 148.767 25.9028 146.436 25.9028C140.849 25.9028 137.591 22.7691 137.591 17.3595C137.591 11.9499 140.675 8.81616 145.682 8.81616C150.689 8.81616 153.532 11.881 153.532 16.9441V18.0796H140.436L140.438 18.087ZM150.721 15.8824C150.516 12.7487 148.801 11.0945 145.751 11.0945C142.701 11.0945 140.746 12.8175 140.506 15.8824H150.721Z" fill="#FDFBFA"/>
                  <path d="M157.098 22.2186C158.365 23.1845 159.874 23.6319 161.76 23.6319C164.057 23.6319 165.292 22.7372 165.292 21.0487C165.292 20.3261 165.053 19.8444 164.539 19.4978C164.151 19.2455 163.008 18.7973 161.11 18.1534C158.094 17.1555 156.824 15.7079 156.824 13.2968C156.824 10.4039 158.744 8.78424 162.205 8.78424C164.228 8.78424 165.737 9.23156 167.381 10.3351L166.251 12.3333C164.947 11.4387 163.783 11.0577 162.342 11.0577C160.525 11.0577 159.498 11.8147 159.498 13.1591C159.498 13.9161 159.874 14.5724 160.559 14.9509C160.925 15.1344 161.804 15.467 163.199 15.9487C166.868 17.1899 167.998 18.3943 167.998 20.943C167.998 24.1799 165.872 25.9029 161.826 25.9029C159.427 25.9029 157.678 25.4555 156.068 24.4233L157.096 22.2186H157.098Z" fill="#FDFBFA"/>
                </g>
                <defs>
                  <clipPath id="clip0_2838_22366">
                    <rect width="168" height="30" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <button
                className="tt-mobile-close-btn"
                onClick={() => {
                  mixpanel.track("mobileMenuClosed");
                  setMobileMenuOpen(false);
                }}
                aria-label="Close menu"
              >
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
                  <path d="M5 5L17 17M17 5L5 17" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            </div>

            <div className="tt-mobile-user-row">
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div className="tt-mobile-user-icon">
                  <UserIcon />
                </div>
                <span className="tt-mobile-user-name">Hi, {userName || "User"}</span>
              </div>
              <button className="tt-mobile-logout-link" onClick={handleLogout}>
                Log out
              </button>
            </div>

            <div className="tt-mobile-nav-list">
              {/* Create a Tree — expands in place */}
              <button
                className={`tt-mobile-nav-item-lg${isCreateTreeGroupActive ? ' active' : ''}`}
                onClick={() => {
                  const willExpand = !createTreeExpanded;
                  mixpanel.track(willExpand ? "mobileCreateTreeExpanded" : "mobileCreateTreeCollapsed");
                  setCreateTreeExpanded((p) => !p);
                }}
                aria-expanded={createTreeExpanded}
                aria-controls="tt-mobile-create-tree-submenu"
              >
                Create a Tree
                <svg
                  className={`tt-chevron${createTreeExpanded ? ' tt-chevron--open' : ''}`}
                  width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"
                >
                  <path d="M4 6l4 4 4-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              {createTreeExpanded && (
                <div id="tt-mobile-create-tree-submenu" className="tt-mobile-submenu">
                  {MOBILE_ORDER.map((key) => {
                    const option = CREATE_TREE_OPTIONS[key];
                    const Icon = option.Icon;
                    const isActive = activeMenu === option.id;
                    return (
                      <button
                        key={option.id}
                        className={`tt-mobile-option-card${isActive ? ' active' : ''}`}
                        aria-current={isActive ? 'page' : undefined}
                        onClick={() => handleCreateTreeSelect(option, "mobile_submenu")}
                      >
                        <span className="tt-mobile-option-icon"><Icon /></span>
                        <span>
                          <span className="tt-mobile-option-title" style={{ display: "block" }}>
                            {option.mobileTitle}
                          </span>
                          <span className="tt-mobile-option-desc" style={{ display: "block" }}>
                            {option.mobileDesc}
                          </span>
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}

              {navItems.map((item) => (
                <button
                  key={item.id}
                  className={`tt-mobile-nav-item-lg${activeMenu === item.id ? ' active' : ''}`}
                  onClick={() => handleNavClick(item)}
                >
                  {item.label}
                </button>
              ))}

              {mobileTopLevelItems.map((item) => (
                <button
                  key={item.id}
                  className={`tt-mobile-nav-item-lg${activeMenu === item.id ? ' active' : ''}`}
                  onClick={() => handleNavClick(item)}
                >
                  {item.label}
                </button>
              ))}

              {externalNavItems.map((item) => (
                <button
                  key={item.id}
                  className="tt-mobile-nav-item-lg"
                  onClick={() => handleExternalNavClick(item)}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* Create a Tree — desktop popup modal */}
      {createTreeOpen && (
        <div
          className="tt-modal-overlay"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
              mixpanel.track("createATreeModalClosed", { method: "overlay_click" });
              setCreateTreeOpen(false);
            }
          }}
        >
          <div className="tt-modal" role="dialog" aria-modal="true" aria-labelledby="tt-create-tree-heading">
            <button
              className="tt-modal-close"
              onClick={() => {
                mixpanel.track("createATreeModalClosed", { method: "close_button" });
                setCreateTreeOpen(false);
              }}
              aria-label="Close"
            >
              <svg width="22" height="22" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path d="M4 4l12 12M16 4L4 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>

            <h2 id="tt-create-tree-heading" className="tt-modal-title">Create a Tree</h2>

            <div className="tt-option-list">
              {DESKTOP_ORDER.map((key) => {
                const option = CREATE_TREE_OPTIONS[key];
                const isActive = activeMenu === option.id;
                return (
                  <button
                    key={option.id}
                    className={`tt-option-card${isActive ? ' active' : ''}`}
                    aria-current={isActive ? 'page' : undefined}
                    onClick={() => handleCreateTreeSelect(option, "desktop_modal")}
                  >
                    <img src={option.illustration} alt="" className="tt-option-illustration" />
                    <span>
                      <span className="tt-option-title" style={{ display: "block" }}>
                        {option.modalTitle}
                      </span>
                      <span className="tt-option-desc" style={{ display: "block" }}>
                        {option.modalDesc}
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>

            <div className="tt-modal-footer">
              <button
                type="button"
                className="tt-manage-link"
                onClick={() => handleCreateTreeSelect({ id: MENU_IDS.RECORDINGS, label: "Manage Trees" })}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
                </svg>
                Manage Trees
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar;